import { ThemeProvider } from '@forgeglobal/design-framework';
import { StyledEngineProvider } from '@mui/material';
import ErrorBoundary from '@tcs/common/components/atoms/ErrorBoundary';
import { AnalyticsProvider } from '@tcs/common/hooks/analytics';
import theme from '@tcs/common/theme';
import { getConfig } from '@tcs/create-account/utils/configService';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

(async () => {
  const config = await getConfig();

  const analyticsConfig = {
    googleAnalyticsTrackingId: config.GOOGLE_ANALYTICS_TRACKING_ID,
    segmentWriteKey: config.SEGMENT_WRITE_KEY,
    heapAppId: config.HEAP_APP_ID,
    appInsightsInstrumentationKey: null,
    logRocketAppId: config.LOGROCKET_APP_ID,
  };

  // initialize launch darkly as generic forgeclient user
  // once logged in, we call .identify in SessionProvider to set the real username
  const user = { key: 'forgeclient', anonymous: true };
  const FeatureFlagProvider = await asyncWithLDProvider({
    clientSideID: config.LAUNCHDARKLY_CLIENT_ID,
    user,
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <BrowserRouter basename={config.REACT_APP_BASE_PATH}>
      <AnalyticsProvider config={analyticsConfig}>
        <FeatureFlagProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider themeCustomization={theme}>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </ThemeProvider>
          </StyledEngineProvider>
        </FeatureFlagProvider>
      </AnalyticsProvider>
    </BrowserRouter>
  );
})();
